export const schedule = {
  addSchedule: "新增排程",
};
